<script lang="ts" setup>
const props = defineProps<{
  isLink?: boolean
}>()

const { t } = useI18n()

const { canCreateSignatureRequest } = storeToRefs(useUserStore())

const { createBlockedTooltip } = useCreateBlockedTooltip()

const isLinkEnabled = computed(() => Boolean(props.isLink) && canCreateSignatureRequest.value)

const linkComponent = resolveComponent('NuxtLink')
</script>

<template>
  <v-tooltip
    content-class="text-center bg-info"
    location="bottom"
    max-width="207"
    :disabled="!isLink || canCreateSignatureRequest"
  >
    <template #activator="{ props: activatorProps }">
      <component
        :is="isLinkEnabled ? linkComponent : 'div'"
        v-bind="activatorProps"
        :to="isLinkEnabled ? { name: 'upload' } : undefined"
        class="credits-badge py-3 px-4 font-weight-bold align-center d-flex text-no-decoration"
        :class="{ 'credits-badge--clickable': isLinkEnabled }"
        data-cy="credits_badge"
      >
        {{ t('global.credits_left') }}
      </component>
    </template>
    <span>{{ createBlockedTooltip }}</span>
  </v-tooltip>
</template>

<style lang="scss" scoped>
.credits-badge {
  background-color: $c-purple-bg;
  color: $c-skribbleu;
  border-radius: 6px;
  font-size: $h4-font-size;
  &--clickable {
    cursor: pointer;
    transition: opacity 0.2s ease-in-out;

    &:hover {
      opacity: 80%;
    }
  }
}
</style>
